module.exports = __webpack_public_path__ + "img/zutto-fizzy.0d4de02.jpg";